import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import { SliceSliderSettings } from './settings/slice-slider-settings.model';


export const SliceSliderDefinition: IdtComponentDefinition = {
  id: 'slice-slider',
  role: IdtComponentRole.Slice,
  numSlots: 0,
};

export const SLICE_SLIDER_DEFAULT_ARROW_TYPE = 'icon';
export const SLICE_SLIDER_DEFAULT_DELAY = 3;
export const SLICE_SLIDER_DEFAULT_NUMBER_OF_SLIDES = 1;
export const SLICE_SLIDER_DEFAULT_SPACE_BETWEEN = 0;
export const SLICE_SLIDER_DEFAULT_INITIAL_OFFSET = '0pt';
export const SLICE_SLIDER_DEFAULT_LAST_OFFSET = '0pt';
export const SLICE_SLIDER_DEFAULT_FX_SLIDE = 'ease';
export const SLICE_SLIDER_DEFAULT_SPEED = 1;
export const SLICE_SLIDER_DEFAULT_INITIAL_SLIDE = 0;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SLICE_SLIDER_DEFAULT_CENTERED_SLIDES = false;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SLICE_SLIDER_DEFAULT_SEPARATOR = false;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SLICE_SLIDER_DEFAULT_REWIND = false;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SLICE_SLIDER_DEFAULT_HIDE_NAVIGATION = false;

export const SliceSliderCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Carrusel',
  group: CmsComponentGroups.Carousels,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): SliceSliderSettings => {
    return {
      general: {
        arrowType: SLICE_SLIDER_DEFAULT_ARROW_TYPE,
        arrowSize: {
          widthDesktop: '20px',
          heightDesktop: '20px',
          widthMobile: '20px',
          heightMobile: '20px',
        },
        autoplay: false,
        direction: 'horizontal',
        transitionType: 'slide',
        initialOffset: SLICE_SLIDER_DEFAULT_INITIAL_OFFSET,
        initialOffsetMobile: SLICE_SLIDER_DEFAULT_INITIAL_OFFSET,
        isDelayEnabled: false,
        lastOffset: SLICE_SLIDER_DEFAULT_LAST_OFFSET,
        lastOffsetMobile: SLICE_SLIDER_DEFAULT_LAST_OFFSET,
        loop: true,
        fxSlide: SLICE_SLIDER_DEFAULT_FX_SLIDE,
        fxSlideMobile: SLICE_SLIDER_DEFAULT_FX_SLIDE,
        numSlots: 1,
        numberOfSlides: SLICE_SLIDER_DEFAULT_NUMBER_OF_SLIDES,
        numberOfSlidesMobile: SLICE_SLIDER_DEFAULT_NUMBER_OF_SLIDES,
        pagerPosition: 'inside-center',
        pagerPositionMobile: 'inside-center',
        paginationType: 'dot',
        paginationTypeMobile: 'dot',
        pagination: false,
        paginationMobile: false,
        scrollMode: 'pager',
        slidesWidthType: 'auto',
        separator: SLICE_SLIDER_DEFAULT_SEPARATOR,
        separatorMobile: SLICE_SLIDER_DEFAULT_SEPARATOR,
        showTitles: false,
        delay: [SLICE_SLIDER_DEFAULT_DELAY],
        speed: SLICE_SLIDER_DEFAULT_SPEED,
        speedMobile: SLICE_SLIDER_DEFAULT_SPEED,
        spaceBetween: SLICE_SLIDER_DEFAULT_SPACE_BETWEEN,
        spaceBetweenMobile: SLICE_SLIDER_DEFAULT_SPACE_BETWEEN,
        titles: [],
        centeredSlides: SLICE_SLIDER_DEFAULT_CENTERED_SLIDES,
        centeredSlidesMobile: SLICE_SLIDER_DEFAULT_CENTERED_SLIDES,
        pauseOnMouseEnter: false,
        rewind: SLICE_SLIDER_DEFAULT_REWIND,
        rewindMobile: SLICE_SLIDER_DEFAULT_REWIND,
        hideNavigation: SLICE_SLIDER_DEFAULT_HIDE_NAVIGATION,
        hideNavigationMobile: SLICE_SLIDER_DEFAULT_HIDE_NAVIGATION,
        displaySlideDescriptions: false,
        slideDescriptions: [],
        initialSlide: SLICE_SLIDER_DEFAULT_INITIAL_SLIDE
      },
      slots: [
        { ...initialSliceSlotState }
      ],
      styles: {
        ...SliceStylesDefaultValues,
        primaryLightColor: '#000',
        secondaryLightColor: '#CCC',
        primaryDarkColor: '#FFF',
        secondaryDarkColor: '#CCC'
      },
      animations: {}
    };
  }
};
